export default __webpack_public_path__ + "static/media/img2.970da062.png";